import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss']
})
export class InputComponent {
    @Input() value: string;
    @Input() disabled: boolean;
    @Input() readonly: string;
    @Input() placeholder: string;

    constructor() { }
}
